import React, { useState } from "react";
import {
  MajesticonsTable,
  MaterialSymbolsSearchRounded,
} from "../../assets/icons/LayoutIcon";
import GridDialogBox from "../Layout/GridDialogBox";

const SearchSection = ({
  onSearch,
  searchPlaceholder = "Search here..",
  tablefields,
  selectedHeaders,
  onHeadersChange,
}) => {
  const [searchTerm, setSearchTerm] = useState("");

  const [openGridDialogBox, setOpenGridDialogBox] = useState(false);

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    if (onSearch) {
      onSearch(value);
    }
  };

  return (
    <div className="justify-between flex mt-4 items-center">
    <div className="flex justify-start items-center border px-2 py-1.5 rounded-md border-gray-300 gap-2">
      <MaterialSymbolsSearchRounded className="text-gray-400 h-5 w-5" />
      <input
        type="text"
        value={searchTerm}
        onChange={handleSearchChange}
        className="w-full rounded pl-2 pr-5 text-sm font-normal text-gray-400 focus:outline-none focus:ring-none"
        placeholder={searchPlaceholder}
      />
    </div>
    <div
      className="px-2.5 py-1.5 border border-gray-200 rounded-md cursor-pointer flex items-center"
      onClick={() => {
        setOpenGridDialogBox(true);
      }}
    >
      <MajesticonsTable className="text-gray-700 h-6 w-6" />
    </div>
  
    {openGridDialogBox && (
      <GridDialogBox
        handleClose={() => setOpenGridDialogBox(false)}
        selectedHeaders={selectedHeaders}
        tablefields={tablefields}
        onHeadersChange={onHeadersChange}
      />
    )}
  </div>
  );
};

export default SearchSection;
